// @ts-nocheck
/* eslint-disable */
export const boldUserCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M14.666 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.333 0M10 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 7.667a5.64 5.64 0 0 0 3.204-.993c.403-.276.575-.803.34-1.232C11.06 10.553 10.06 10 8 10s-3.06.553-3.546 1.442c-.234.429-.062.956.341 1.232A5.64 5.64 0 0 0 8 13.667" clip-rule="evenodd"/></svg>`,
    name: 'bold-user-circle' as const
};